import { Component, OnInit } from '@angular/core';
import { Globals } from '../globals';
import { Router } from '@angular/router';
import { CryptoJs } from 'app/shared/crypto-js/crypto-js.component';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {
    fullName: string = '';

    constructor(
        public _Globals: Globals,
        public _CryptoJs: CryptoJs,
        private router: Router) {
        this.fullName = this._Globals.getFullName();
    }

    ngOnInit() { }

    changeMode(mode: string) {
        console.log("change mode: ", mode);

        this._Globals.deactivateAllModes();
        switch (mode) {
            case "Administrator":
                this._Globals.admin = true;
                localStorage.setItem("kUvPfGbd6J", this._CryptoJs.encrypt("Administrator", '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                this.router.navigate(['app/admin_dashboard',]);
                break;
            case "Coach":
                this._Globals.coach = true;
                localStorage.setItem("kUvPfGbd6J", this._CryptoJs.encrypt("Coach", '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                this.router.navigate(['app/coach_home',]);
                break;
            case "Client":
                this._Globals.client = true;
                localStorage.setItem("kUvPfGbd6J", this._CryptoJs.encrypt("Client", '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                this.router.navigate(['app/client_assessments',]);
                break;
            case "Rater":
                this._Globals.rater = true;
                localStorage.setItem("kUvPfGbd6J", this._CryptoJs.encrypt("Rater", '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                this.router.navigate(['app/rater_assessments',]);
                break;
        }
    }

    toggleUserMenu() {
        //close side bar menu if is open
        $('body').removeClass('nav-open');
        this._Globals.sidebarVisible = false;
        console.log('toggle user menu');

        $('.responsive-menu-wrap').toggleClass('toogleMenu');
        var open = $('.responsive-menu-wrap').hasClass('toogleMenu');
        if (open) {
            $('.main-panel').css('margin-left', -225);
            $('.menu-backdrop').css('right', 0);
        } else {
            $('.main-panel').css('margin-left', 0);
            $('.menu-backdrop').css('right', '-100%');
        }
    }

    clickedOut(event) {
        console.log(event);
        if (event.target.className == "menu-backdrop") {
            this.toggleUserMenu();
        }
    }

    logout() {
        this._Globals.deactivateAllModes();
        this._Globals.isLoggedIn = false;
        this._Globals.selectedMode = undefined;
        this.router.navigate(['login',]);
        this._Globals.deleteAllStorage();
    }

}
